import * as React from "react";
import { css, Global } from "@emotion/react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { routeCustomerTargetActions } from "../features/route-pair-target-table/redux/actions";
import { RouteTargetPageWrapper } from "./RouteTargetPageWrapper";
import { Helmet } from "react-helmet";
import { useParams } from "react-router";

export const RouteTargetScreen: React.FC = () => {
  const { routePairCode } = useParams() as { routePairCode: string };

  return (
    <>
      <Global
        styles={css`
          body {
            display: table;
          }
        `}
      />
      <Helmet title={`Route targets - ${routePairCode}`} />
      <RouteTargetPageWrapper />
    </>
  );
};
